export interface ProductTypeFormConfig {
  header: string;
  controlName: string;
  showIcon: boolean;
  message: string;
}
